module.exports = __webpack_public_path__ + "img/favicon.bebd051c.png";